module.exports = __webpack_public_path__ + "static/media/_VISA.e9d3a7f5.svg";